const OPTION_WORD = "Word";
const OPTION_TRANSLATION = "Translation";
const OPTION_DEFINITION = "Definition";
const OPTION_SENTENCE = "Sentence";
const OPTION_PARTS_OF_SPEECH = "Parts of Speech";

export const TRANSLATION = "translation";
export const LANGUAGE_ENGLISH = "EN";

export const optionConstants = [
  OPTION_WORD,
  OPTION_TRANSLATION,
  OPTION_PARTS_OF_SPEECH,
  OPTION_DEFINITION,
  OPTION_SENTENCE,
];

export const POS_DETAILS = [
  { posId: 1, pos: "noun" },
  { posId: 2, pos: "noun phrase" },
  { posId: 3, pos: "adjective" },
  { posId: 4, pos: "adjective phrase" },
  { posId: 5, pos: "verb" },
  { posId: 6, pos: "phrasal verb" },
  { posId: 7, pos: "verb phrase" },
  { posId: 8, pos: "adverb" },
  { posId: 9, pos: "adverb phrase" },
  { posId: 10, pos: "preposition" },
  { posId: 11, pos: "prepositional phrase" },
  { posId: 12, pos: "expression" },
  { posId: 13, pos: "conjunction" },
  { posId: 14, pos: "idiom" },
];
